
export default function ValidationsCreateSolicitacao() {

    async function validateFields(data, processoItemList) {

        if (!data.codigoCompliance) {
            return { campo: "codigoCompliance", message: "Um Compliance deve ser associado a solicitação." };
        }

        if (!data.nomeUnidadeGerencia) {
            return { campo: "nomeUnidadeGerencia", message: "Selecione uma Unidade/Gerência." };
        }

        if (!data.nomeAuditor) {
            return { campo: "nomeAuditor", message: "Selecione um Auditor(a)." };
        }

        if (!data.prazoSolicitacao) {
            return { campo: "prazoSolicitacao", message: "Selecione um prazo para esta solicitação." };
        }

        if (!data.templateEmailComunicado) {
            return { campo: "templateEmailComunicado", message: "Selecione um template de e-mail para comunicado." };
        }

        if (!data.templateEmailSolicitacao) {
            return { campo: "templateEmailSolicitacao", message: "Selecione um template de e-mail para solicitação." };
        }

        const hasNoSelectedItem = !processoItemList.some((item) => item.flagSelecionado);

        if (hasNoSelectedItem) {
            return { campo: "itensProcesso", message: "Pelo menos um item do processo deve ser associado à solicitação." };
        }

        return null;
    }

    return { validateFields };
}
